module.exports = __webpack_public_path__ + "static/media/10.question.3215937e.mp4";